export default "__VITE_ASSET__DQdfcpHM__"